import { TrustpilotStars } from "@airhelp/badges";
import { TrustPilot } from "@airhelp/icons";
import { ComponentProps } from "react";
import { Text, Flex, Link, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useTrustpilotScore } from "v2/modules/trustpilot-score";

export function FunnelTrustpilot({ className, ...props }: TrustpilotProps) {
  const { scoreValue, trustpilotLink, totalReviews } = useTrustpilotScore();
  const { t } = useTranslation();

  const formatThousands = (value: string) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Link href={trustpilotLink} target="_blank" rel="noopener">
      <Flex
        className={className}
        data-testid="funnel-trustpilot"
        justifyContent={{ base: "center", md: "flex-start" }}
        flexWrap="wrap"
        rowGap={2}
        {...props}
      >
        <Flex
          data-testid="trustpilot-excellent"
          sx={{
            svg: {
              width: 109,
              height: 22,
            },
          }}
          mr={4}
        >
          <TrustpilotStars
            starLabelText={t("footer.trustpilot.excellent")}
            numberOfStars={scoreValue}
            isLogoHidden
          />
        </Flex>
        <HStack gap={0}>
          <Text fontSize="sm" fontWeight="bold" color="primary.900" mr={1}>
            {formatThousands(totalReviews.toString())}
          </Text>
          <Text fontSize="sm" color="primary.900">
            {t("footer.trustpilot.reviews_on")}
          </Text>
          <TrustPilot ml={2} w={5} h={5} />
          <Text fontSize="sm" fontWeight="bold" color="primary.900">
            Trustpilot
          </Text>
        </HStack>
      </Flex>
    </Link>
  );
}

type TrustpilotProps = ComponentProps<typeof Flex> & {
  className?: string;
};
